<style>
.infobox .infoboxleft .colorcolumn {
  background: #F7F7F7 !important;
}

.infobox .infoboxleft .colorcolumn .ivu-table-cell {
  padding: 0 !important;
  text-align: center !important;
}

.resultbox .ivu-form .ivu-form-item-label {
  text-align: center !important;
}

.resultbox .ivu-select {
  width: 361px;
}

.resultbox .ivu-input-type-text {
  width: 800px;
}
</style>
<template>
  <div>
    <page-head :title="title" :btn-list="btnList" @handleBtn="handleBtn"></page-head>
    <div class="content">
      <div class="detailbox" style="margin-top: 0;">
        <div class="boxtop"><span>基本信息</span><span>{{ verifyResult }}</span><span
            v-if="remarkValue && verifyResult != '大数据校验成功'">({{ remarkValue }})</span></div>
        <div class="infobox">
          <div class="infoboxleft">
            <i-table size="small" border :show-header="false" :columns="columns" :data="data0"></i-table>
          </div>
          <div class="infoboxright" v-if="verifyResult != '大数据校验成功'">
            <RadioGroup v-model="formItem.checkbox0">
              <Radio label="基本信息合格"></Radio>
              <Radio label="基本信息不合格"></Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="imgbox">
          <!-- <img v-for="(item,index) in photos.imgList0" :src="item.imgPath"  @click.stop="clickPic(photos.imgList0,index)" /> -->
          <el-image v-for="(item, index) in photos.imgList0" :key="index" :src="item.imgPath"
            :preview-src-list="previewlist0" style="width: 200px;height: 200px;margin-top: 20px;margin-left: 20px;" />
        </div>
      </div>
      <div class="detailbox">
        <div class="boxtop"><span>户籍信息</span><span>{{ verifyResult1 }}</span><span
            v-if="remarkValue1 && verifyResult1 != '大数据校验成功'">({{ remarkValue1 }})</span></div>
        <div class="infobox">
          <div class="infoboxleft">
            <i-table size="small" border :show-header="false" :columns="columns" :data="data1"></i-table>
          </div>
          <div class="infoboxright" v-if="verifyResult1 != '大数据校验成功'">
            <RadioGroup v-model="formItem.checkbox1">
              <Radio label="户籍信息合格"></Radio>
              <Radio label="户籍信息不合格"></Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="imgbox">
          <!-- <img v-for="(item,index) in photos.imgList1" :src="item.imgPath" @click.stop="clickPic(photos.imgList1,index)" /> -->
          <el-image v-for="(item, index) in photos.imgList1" :key="index" :src="item.imgPath"
            :preview-src-list="previewlist1" style="width: 200px;height: 200px;margin-top: 20px;margin-left: 20px;" />
        </div>
      </div>

      <div class="detailbox">
      <div class="modifylandnumbox">
        <div class="modifylandnum1" @click="showSelectGuardianEstateByCardno(data3[0].title4, data3[2].title4)"><span>购房合同(预告登记)</span></div>
        <div class="modifylandnum" @click="showEstateInfo(data3[0].title4, data3[2].title4)"><span>房产信息</span></div>
      </div>
      
     
        <div class="boxtop"><span>监护人信息</span><span>{{ verifyResult3 }}</span><span
            v-if="remarkValue3 && verifyResult3 != '大数据校验成功'">({{ remarkValue3 }})</span></div>
        <div class="infobox">
          <div class="infoboxleft">
            <i-table size="small" border :show-header="false" :columns="columns" :data="data3"></i-table>
          </div>
          <div class="infoboxright" v-if="verifyResult3 != '大数据校验成功'">
            <RadioGroup v-model="formItem.checkbox3">
              <Radio label="身份证件1合格"></Radio>
              <Radio label="身份证件1不合格"></Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="imgbox">
          <!-- <img v-for="(item,index) in photos.imgList3" :src="item.imgPath" @click.stop="clickPic(photos.imgList3,index)" /> -->
          <el-image v-for="(item, index) in photos.imgList3" :key="index" :src="item.imgPath"
            :preview-src-list="previewlist3" style="width: 200px;height: 200px;margin-top: 20px;margin-left: 20px;" />
        </div>
      </div>
      <div class="detailbox">
        <div class="modifylandnumbox">
          <div class="modifylandnum1" @click="showSelectGuardianEstateByCardno(data4[0].title4, data4[2].title4)"><span>购房合同(预告登记)</span></div>
          <div class="modifylandnum" @click="showEstateInfo(data4[0].title4, data4[2].title4)"><span>房产信息</span></div>
        </div>
        
        <div class="boxtop"><span>监护人二信息</span><span>{{ verifyResult4 }}</span>
          <span v-if="remarkValue4 && verifyResult4 != '大数据校验成功'">({{ remarkValue4 }})</span>
        </div>
        <div class="infobox">
          <div class="infoboxleft">
            <i-table size="small" border :show-header="false" :columns="columns" :data="data4"></i-table>
          </div>
          <div class="infoboxright" v-if="verifyResult4 != '大数据校验成功'">
            <RadioGroup v-model="formItem.checkbox4">
              <Radio label="身份证件2合格"></Radio>
              <Radio label="身份证件2不合格"></Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="imgbox">
          <!-- <img v-for="(item,index) in photos.imgList4" :src="item.imgPath" @click.stop="clickPic(photos.imgList4,index)" /> -->
          <el-image v-for="(item, index) in photos.imgList4" :key="index" :src="item.imgPath"
            :preview-src-list="previewlist4" style="width: 200px;height: 200px;margin-top: 20px;margin-left: 20px;" />
        </div>
      </div>
      <div class="detailbox" v-if="studentType != 3 && publicktype != 3">
        <div v-if="showmodifylandnum" class="modifylandnum" @click="landnumModify"><span>地丘修改</span></div>
        <div class="boxtop"><span>居住信息</span><span>{{ verifyResult2 }}</span><span
            v-if="remarkValue2 && verifyResult2 != '大数据校验成功'">({{ remarkValue2 }})</span></div>
        <div class="infobox">
          <div class="infoboxleft">
            <i-table size="small" border :show-header="false" :columns="columnsjz" :data="data2">
              <template slot-scope="{ row, column, index }" slot="title2">
                {{row.title2}}
                <template v-if="index==1">
                  <span style="color: #2D8cF0" @click="showEstateInfo(data2[1].title2, data2[1].title4)">[查看]</span>
                </template>
              </template>
              <template slot-scope="{ row, column, index }" slot="title4">
                {{row.title4}}
                <template v-if="index==0">
                  <span style="color: #2D8cF0" @click="showLiveInfo(data2)">[查看]</span>
                </template>
              </template>
            </i-table>
          </div>
          <div class="infoboxright" v-if="verifyResult2 != '大数据校验成功'">
            <RadioGroup v-model="formItem.checkbox2">
              <Radio label="房产信息合格"></Radio>
              <Radio label="房产信息不合格"></Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="imgbox">
          <!-- <img v-for="(item,index) in photos.imgList2" :src="item.imgPath" @click.stop="clickPic(photos.imgList2,index)" /> -->
          <el-image v-for="(item, index) in photos.imgList2" :key="index" :src="item.imgPath"
            :preview-src-list="previewlist2" style="width: 200px;height: 200px;margin-top: 20px;margin-left: 20px;" />
        </div>
      </div>

      <div class="detailbox" v-if="schooltype != 3 && residencePermitName && publicktype != 3">
        <div class="boxtop"><span>居住证信息</span><span>{{ verifyResult5 }}</span><span
            v-if="remarkValue5 && verifyResult5 != '大数据校验成功'">({{ remarkValue5 }})</span></div>
        <div class="infobox">
          <div class="infoboxleft">
            <i-table size="small" border :show-header="false" :columns="columns" :data="data5"></i-table>
          </div>
          <div class="infoboxright" v-if="verifyResult5 != '大数据校验成功'">
            <RadioGroup v-model="formItem.checkbox5">
              <Radio label="居住证信息合格"></Radio>
              <Radio label="居住证信息不合格"></Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="imgbox">
          <!-- <img v-for="(item,index) in photos.imgList5" :src="item.imgPath" @click.stop="clickPic(photos.imgList5,index)" /> -->
          <el-image v-for="(item, index) in photos.imgList5" :key="index" :src="item.imgPath"
            :preview-src-list="previewlist5" style="width: 200px;height: 200px;margin-top: 20px;margin-left: 20px;" />
        </div>
      </div>
      <div class="detailbox" v-if="schooltype != 3 && workName && publicktype != 3">
        <div class="boxtop"><span>工作信息</span><span>{{ verifyResult6 }}</span><span
            v-if="remarkValue6 && verifyResult6 != '大数据校验成功'">({{ remarkValue6 }})</span></div>
        <div class="infobox">
          <div class="infoboxleft">
            <i-table size="small" border :show-header="false" :columns="columns" :data="data6"></i-table>
          </div>
          <div class="infoboxright" v-if="verifyResult6 != '大数据校验成功'">
            <RadioGroup v-model="formItem.checkbox6">
              <Radio label="工作信息合格"></Radio>
              <Radio label="工作信息不合格"></Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="imgbox">
          <!-- <img v-for="(item,index) in photos.imgList6" :src="item.imgPath" @click.stop="clickPic(photos.imgList6,index)" /> -->
          <el-image v-for="(item, index) in photos.imgList6" :key="index" :src="item.imgPath"
            :preview-src-list="previewlist6" style="width: 200px;height: 200px;margin-top: 20px;margin-left: 20px;" />
        </div>
      </div>
      <div class="detailbox" v-if="schooltype != 3 && busWorkType == '经营' && publicktype != 3">
        <div class="boxtop"><span>工作信息</span><span>{{ verifyResult6 }}</span><span
            v-if="remarkValue6 && verifyResult6 != '大数据校验成功'">({{ remarkValue6 }})</span></div>
        <div class="infobox">
          <div class="infoboxleft">
            <i-table size="small" border :show-header="false" :columns="columns" :data="data6"></i-table>
          </div>
          <div class="infoboxright" v-if="verifyResult6 != '大数据校验成功'">
            <RadioGroup v-model="formItem.checkbox6">
              <Radio label="工作信息合格"></Radio>
              <Radio label="工作信息不合格"></Radio>
            </RadioGroup>
          </div>
        </div>
        <div class="imgbox">
          <!-- <img v-for="(item,index) in photos.imgList6" :src="item.imgPath" @click.stop="clickPic(photos.imgList6,index)" /> -->
          <el-image v-for="(item, index) in photos.imgList6" :key="index" :src="item.imgPath"
            :preview-src-list="previewlist6" style="width: 200px;height: 200px;margin-top: 20px;margin-left: 20px;" />
        </div>
      </div>

      <div class="detailbox">
        <div class="boxtop"><span>审核信息</span></div>
        <div class="infobox">
          <div class="infoboxleft">
            <i-table size="small" border :show-header="false" :columns="columnssh" :data="dataresult"></i-table>
          </div>
        </div>
      </div>

      <div class="detailbox" v-if="page != 'pleasedel'">
        <div class="boxtop1">
          <div>审核结果</div>
          <div v-if="schooltype == 3 && auditPermissions == 2">
            <span v-if="formItems.selects != '不通过'" @click.stop="handleBtn('checkPass')">确认复审</span>
            <span v-if="formItems.selects == '不通过'" @click.stop="handleBtn('checkPass')">确认退回</span>
          </div>
          <div v-else-if="schooltype == 3 && auditPermissions == 3">
            <span @click.stop="handleBtn('checkPass')">确认交叉复审</span>
          </div>
          <div v-else-if="schooltype == 3 && auditPermissions != 2">
            <span @click.stop="handleBtn('checkPass')">确认初审</span>
          </div>
          <div v-else-if="schooltype != 3 && auditPermissions == 2">
            <span v-if="formItems.selects != '不通过'" @click.stop="handleBtn('checkPass')">确认审核</span>
            <span v-if="formItems.selects == '不通过'" @click.stop="handleBtn('checkPass')">确认退回</span>
          </div>
          <div v-else-if="schooltype != 3 && auditPermissions != 2">
            <span @click.stop="handleBtn('checkPass')">确认审核</span>
          </div>
        </div>
        <div class="resultbox">
          <Form :model="formItems" :label-width="106">
            <FormItem label="审核结果">
              <Select v-model="formItems.selects" @on-change="selectschange">
                <Option value="通过">通过</Option>
                <Option value="不通过">不通过</Option>
              </Select>
            </FormItem>
            <FormItem label="审核备注">
              <Input v-model="formItems.tips" placeholder="请输入审核结果原因" />
            </FormItem>
          </Form>
        </div>
      </div>
    </div>

    <Modal v-model="modal1" title="修改地丘号" height="500" draggable>
      <i-form ref="search" :model="landquery" style="height:200px;">
        <row>
          <i-col span="24">
            <form-item prop="landnum">
              <Input v-model="landquery.landnum" clearable placeholder="请输入要修改的地丘号" />
            </form-item>
          </i-col>
        </row>
      </i-form>
      <div slot="footer">
        <Button type="info" @click="docancel">取消</Button>
        <Button type="success" @click="dosure">确认修改</Button>
      </div>
    </Modal>

    <Modal v-model="liveModalVisible" title="居住信息" width="1000">
      <LiveInfo :data="liveInfoDate"></LiveInfo>
    </Modal>

    <Modal v-model="estateInfoVisible" title="房产信息" width="1000">
      <EstateInfo :data="estateInfoDate"></EstateInfo>
    </Modal>

    <Modal v-model="estateInfoVisible1" title="购房合同(预告登记)" width="1000">
      <EstateInfo1 :data="estateInfoDate1"></EstateInfo1>
    </Modal>

    <preview-img :currentIndex="currentIndex" :imgArr="showPreview.list" v-if="showPreview.show"
      v-on:closePreview="closePreview">
    </preview-img>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
import PreviewImg from "../../../components/previewImg";
import LiveInfo from "./components/LiveInfo";
import EstateInfo from "./components/EstateInfo";
import EstateInfo1 from "./components/EstateInfo1";
const { getselectAllInfo, getadminVerify, getselectVerifyInfo, selectVerifyImage, selectVerifyRemark, setLandNumAuth,
  setLandNum, getJudicialDetail, getEstateList, getselectGuardianEstateByCardno } = api;
const TYPEMAP = {
  0: {
    checkStatus: "审核未通过"
  },
  1: {
    checkStatus: "审核已通过"
  },
  2: {
    checkStatus: "待审核"
  }
};
const resulttype = {
  0: "未审核",
  1: "初审成功",
  2: "初审失败",
  3: "复审成功",
  4: "复审退回",
  5: "重新上报",
  6: '未审核'
}
const resulttype1 = {
  0: "未审核",
  1: "审核成功",
  2: "审核退回",
  5: "重新上报"
}

const STATUSMAP = {
  0: { verifyResult: "大数据校验成功" },
  1: { verifyResult: "未上传材料" },
  2: { verifyResult: "已上传材料" },
  3: { verifyResult: "材料上传不完整" },
  4: { verifyResult: "材料初审成功" },
  5: { verifyResult: "材料复审成功" },
};
export default {
  name: "newStudentsDetail",
  components: {
    pageHead,
    PreviewImg,
    LiveInfo,
    EstateInfo,
    EstateInfo1
  },
  data() {
    return {
      page: "",
      busWorkType: "",
      workName: "",
      showmodifylandnum: false,
      landquery: {
        landnum: ''
      },
      modal1: false,
      liveModalVisible: false,
      estateInfoVisible: false,
      estateInfoVisible1: false,
      liveInfoDate: {},
      estateInfoDate: [],
      estateInfoDate1: [],
      auditPermissions: 0,
      studentId: "",
      studentType: "",//0.城镇常驻居民 1.外来务工人员 2.其他符合的  3.无购房无租房
      title: "新生入学",
      schooltype: '',//1  小学   2初中  3五升六
      publicktype: "",//1  公办   2民办
      residencePermitName: '',
      btnList: [
      ],
      remarkValue: '',
      remarkValue1: '',
      remarkValue2: '',
      remarkValue3: '',
      remarkValue4: '',
      remarkValue5: '',
      remarkValue6: '',
      verifyResult: '',
      verifyResult1: '',
      verifyResult2: '',
      verifyResult3: '',
      verifyResult4: '',
      verifyResult5: '',
      verifyResult6: '',
      "studentInfo": null,
      "studentRegister": null,
      "studentGuardianOne": null,
      "studentGuardianTwo": null,
      "studentEstate": null,
      "studentPermit": null,
      "studentWork": null,
      currentIndex: 0,
      showPreview: {
        show: 0,
        list: [],
      },
      previewlist0: [],
      previewlist1: [],
      previewlist2: [],
      previewlist3: [],
      previewlist4: [],
      previewlist5: [],
      previewlist6: [],
      photos: {
        imgList0: [],
        imgList1: [],
        imgList2: [],
        imgList3: [],
        imgList4: [],
        imgList5: [],
        imgList6: [],
      },
      formItem: {
        checkbox0: '',
        checkbox1: '',
        checkbox2: '',
        checkbox3: '',
        checkbox4: '',
        checkbox5: '',
        checkbox6: ""
      },
      formItems: {
        notice: '',
        tips: '',
        selects: ''
      },
      columns: [{ title: 'title1', key: 'title1', className: 'colorcolumn', width: 132 },
      { title: 'title2', key: 'title2' },
      { title: 'title3', key: 'title3', className: 'colorcolumn', width: 132 },
      { title: 'title4', key: 'title4' }
      ],
      columnssh: [{ title: 'title1', key: 'title1', className: 'colorcolumn', width: 132 },
      { title: 'title2', key: 'title2' },
      { title: 'title3', key: 'title3', className: 'colorcolumn', width: 132 },
      { title: 'title4', key: 'title4' },
      { title: 'title5', key: 'title5', className: 'colorcolumn', width: 132 },
      { title: 'title6', key: 'title6' },
      ],
      columnsjz: [{ title: 'title1', key: 'title1', className: 'colorcolumn', width: 132 },
      { title: 'title2', slot: 'title2' },
      { title: 'title3', key: 'title3', className: 'colorcolumn', width: 132 },
      { title: 'title4', slot: 'title4' }
      ],
      data0: [
        { title1: '学生姓名', title2: '', title3: '性别', title4: '' },
        { title1: '国家地区', title2: '', title3: '民族', title4: '' },
        { title1: '身份证号', title2: '', title3: '报名年级', title4: '' },
        { title1: '出生日期', title2: '', title3: '手机号', title4: '' },
      ],
      data1: [
        { title1: '学生落户时间', title2: '', title3: '户号', title4: '' },
        { title1: '户主姓名', title2: '', title3: '学生与户主关系', title4: '' },
        { title1: '学生籍贯', title2: '', title3: '户籍完整地址', title4: '' },
      ],
      data2: [{ title1: '房产证件类型', title2: '', title3: '房产证编号', title4: '' },
      { title1: '房产登记日期', title2: '', title3: '使用人姓名', title4: '' },
      { title1: '使用人身份证号', title2: '', title3: '使用人与学生关系', title4: '' },
      { title1: '产权比例', title2: '', title3: '房屋完整地址', title4: '' }
      ],
      data3: [
        { title1: '与学生关系', title2: '', title3: '姓名', title4: '' },
        { title1: '姓名', title2: '', title3: '国家地区', title4: '' },
        { title1: '证件类型', title2: '', title3: '证件号', title4: '' },
        { title1: '手机号码', title2: '', title3: '工作单位', title4: '' },
        { title1: '户籍地址', title2: '', title3: '', title4: '' },
      ],
      data4: [
        { title1: '与学生关系', title2: '', title3: '姓名', title4: '' },
        { title1: '姓名', title2: '', title3: '国家地区', title4: '' },
        { title1: '证件类型', title2: '', title3: '证件号', title4: '' },
        { title1: '手机号码', title2: '', title3: '工作单位', title4: '' },
        { title1: '户籍地址', title2: '', title3: '', title4: '' }
      ],
      data5: [
        { title1: '居住证姓名', title2: '', title3: '签发派出所', title4: '' },
        { title1: '居住证办理日期', title2: '', title3: '居住证开始有效期', title4: '' },
        { title1: '居住证结束有效期', title2: '', title3: '最近居住证登记地址', title4: '' },
        { title1: '上一张居住证开始有效期', title2: '', title3: '上一张居住证结束有效期', title4: '' },
        { title1: '再上一张居住证开始有效期', title2: '', title3: '再上一张居住证结束有效期', title4: '' },
      ],
      data6: [
        { title1: '工作人姓名', title2: '', title3: '工作类型', title4: '' },
        { title1: '劳动合同签订日期', title2: '', title3: '用人单位全称', title4: '' },
        { title1: '社保缴纳方式', title2: '', title3: '参保证明校验码', title4: '' },
        { title1: '社保缴纳开始日期', title2: '', title3: '社保缴纳月数', title4: '' },
        { title1: '参保单位名称', title2: '', title3: '参保单位地址', title4: '' },
      ],
      dataresult: [
        { title1: '初审状态', title2: '', title3: '复审状态', title4: '', title5: '交叉复审状态', title6: '' },
        { title1: '初审备注', title2: '', title3: '复审备注', title4: '', title5: '交叉复审备注', title6: '' },
        { title1: '初审用户', title2: '', title3: '复审用户', title4: '', title5: '交叉复审用户', title6: '' },
        { title1: '初审时间', title2: '', title3: '复审时间', title4: '', title5: '交叉复审时间', title6: '' }
      ],
      typeList: [
        {
          index: 0,
          type: "未通过"
        },
        {
          index: 1,
          type: "已通过"
        },
        {
          index: 2,
          type: "待审核"
        }
      ],
    };
  },
  methods: {
    selectschange(e) {
      if (e == '通过') {
        this.formItems.tips = '通过'
      } else {
        this.formItems.tips = ''
      }
    },
    async getsetLandNumAuth() {//获取修改地丘号权限
      let that = this
      let url = setLandNumAuth + localStorage["uid"]
      let res = await this.$post(url);
      console.log(res);
      if (res.isSucceed) {
        if (res.rows && res.rows[0]) {
          if (res.rows[0] == 1) {
            this.showmodifylandnum = true
          }
        }
      }
    },
    landnumModify() {
      this.modal1 = true
    },
    async dosure() {
      let that = this
      if (!this.landquery.landnum) {
        this.$Message.success("请输入要修改的地丘号");
        return;
      }
      let { studentId } = this.$route.query;
      let url = setLandNum + localStorage["uid"] + "/" + studentId + "/" + this.landquery.landnum

      let res = await this.$post(url);
      console.log(res);
      if (res.isSucceed) {
        if (res.message) {
          this.$Message.success(res.message);
        } else {
          this.$Message.success("修改成功");
        }
        this.getDetail();
        this.modal1 = false
      } else {
        if (res.message) {
          this.$Message.success(res.message);
        } else {
          this.$Message.success("修改失败");
        }
      }

    },
    docancel() {
      this.modal1 = false
      this.landquery.landnum = ''
    },
    closePreview() {
      console.log("========closePreview==========");
      this.showPreview.list = []
      this.showPreview.show = 0;
    },
    clickPic(val, index) {
      this.showPreview.list = [];
      console.log(val);
      console.log(index)
      this.currentIndex = index
      val.length > 0 && val.forEach((item) => {
        this.showPreview.list.push({ isHeight: true, path: item.imgPath });
      });
      console.log(this.showPreview.list);
      this.showPreview.show = 1;
    },
    async getselectVerifyRemark() {
      let that = this
      let { studentId } = this.$route.query;
      let url = selectVerifyRemark + studentId
      let res = await this.$post(url);
      console.log(res)
      if (res.isSucceed) {
        if (res.rows) {
          for (let i = 0; i < res.rows.length; i++) {
            if (res.rows[i].remarkType == '其他') {
              let tips = res.rows[i].remarkValue
              this.remarkValue = tips
            } else if (res.rows[i].remarkType == '户口簿') {
              let tips = res.rows[i].remarkValue
              this.remarkValue1 = tips
            } else if (res.rows[i].remarkType == '监护人1') {
              let tips = res.rows[i].remarkValue
              this.remarkValue3 = tips
            } else if (res.rows[i].remarkType == '监护人2') {
              let tips = res.rows[i].remarkValue
              this.remarkValue4 = tips
            } else if (res.rows[i].remarkType == '房产证') {
              let tips = res.rows[i].remarkValue
              this.remarkValue2 = tips
            } else if (res.rows[i].remarkType == '居住证') {
              let tips = res.rows[i].remarkValue

              this.remarkValue5 = tips
            } else if (res.rows[i].remarkType == '工作材料') {
              let tips = res.rows[i].remarkValue
              this.remarkValue6 = tips
            }
          }
        }
      }
    },
    async selectVerifyImage() {
      let that = this
      let { studentId } = this.$route.query;
      let url = selectVerifyImage + studentId
      let res = await this.$get(url);
      if (res.isSucceed) {
        if (res.rows && res.rows.length > 0) {
          let listobj0 = []
          let listobj1 = []
          let listobj2 = []
          let listobj3 = []
          let listobj4 = []
          let listobj5 = []
          let listobj6 = []
          this.previewlist0 = []
          this.previewlist1 = []
          this.previewlist2 = []
          this.previewlist3 = []
          this.previewlist4 = []
          this.previewlist5 = []
          this.previewlist6 = []
          for (let i = 0; i < res.rows.length; i++) {
            if (res.rows[i].imageModule == '基本信息' && res.rows[i].imageType == "其他") {
              listobj0.push({
                imgPath: res.rows[i].imageUrl,
                name: res.rows[i].imageName,
                id: res.rows[i].wxImageId,
              })
              this.previewlist0.push(res.rows[i].imageUrl)
            } else if (res.rows[i].imageModule == '户籍信息' && res.rows[i].imageType == "户口簿") {
              listobj1.push({
                imgPath: res.rows[i].imageUrl,
                name: res.rows[i].imageName,
                id: res.rows[i].wxImageId,
              })
              this.previewlist1.push(res.rows[i].imageUrl)
            } else if (res.rows[i].imageModule == '房产信息' && res.rows[i].imageType == "房产证") {
              listobj2.push({
                imgPath: res.rows[i].imageUrl,
                name: res.rows[i].imageName,
                id: res.rows[i].wxImageId,
              })
              this.previewlist2.push(res.rows[i].imageUrl)
            } else if (res.rows[i].imageModule == '监护人信息' && res.rows[i].imageType == "监护人1") {
              listobj3.push({
                imgPath: res.rows[i].imageUrl,
                name: res.rows[i].imageName,
                id: res.rows[i].wxImageId,
              })
              this.previewlist3.push(res.rows[i].imageUrl)
            } else if (res.rows[i].imageModule == '监护人信息' && res.rows[i].imageType == "监护人2") {
              listobj4.push({
                imgPath: res.rows[i].imageUrl,
                name: res.rows[i].imageName,
                id: res.rows[i].wxImageId,
              })
              this.previewlist4.push(res.rows[i].imageUrl)
            } else if (res.rows[i].imageModule == '居住证信息' && res.rows[i].imageType == "居住证") {
              listobj5.push({
                imgPath: res.rows[i].imageUrl,
                name: res.rows[i].imageName,
                id: res.rows[i].wxImageId,
              })
              this.previewlist5.push(res.rows[i].imageUrl)
            } else if (res.rows[i].imageModule == '工作信息' && res.rows[i].imageType == "工作材料") {
              listobj6.push({
                imgPath: res.rows[i].imageUrl,
                name: res.rows[i].imageName,
                id: res.rows[i].wxImageId,
              })
              this.previewlist6.push(res.rows[i].imageUrl)
            }
          }
          that.photos = {
            imgList0: listobj0,
            imgList1: listobj1,
            imgList2: listobj2,
            imgList3: listobj3,
            imgList4: listobj4,
            imgList5: listobj5,
            imgList6: listobj6,
          }
        }
      }
    },
    async getselectVerifyInfo() {
      let that = this
      let { studentId } = this.$route.query;
      let url = getselectVerifyInfo + studentId
      let res = await this.$get(url);
      console.log(res);
      if (res.isSucceed && res.rows && res.rows.length > 0) {
        for (let i = 0; i < res.rows.length; i++) {
          if (res.rows[i].verifyResult == null) {
            res.rows[i].verifyResult == 1
          }
          if (res.rows[i].imageType == '学生信息' || res.rows[i].imageType == '其他') {
            that.verifyResult = STATUSMAP[res.rows[i].verifyResult] ? STATUSMAP[res.rows[i].verifyResult].verifyResult : null
          } else if (res.rows[i].imageType == '户口簿') {
            that.verifyResult1 = STATUSMAP[res.rows[i].verifyResult] ? STATUSMAP[res.rows[i].verifyResult].verifyResult : null
          } else if (res.rows[i].imageType == '房产证') {
            that.verifyResult2 = STATUSMAP[res.rows[i].verifyResult] ? STATUSMAP[res.rows[i].verifyResult].verifyResult : null
          } else if (res.rows[i].imageType == '监护人1') {
            that.verifyResult3 = STATUSMAP[res.rows[i].verifyResult] ? STATUSMAP[res.rows[i].verifyResult].verifyResult : null
          } else if (res.rows[i].imageType == '监护人2') {
            that.verifyResult4 = STATUSMAP[res.rows[i].verifyResult] ? STATUSMAP[res.rows[i].verifyResult].verifyResult : null
          } else if (res.rows[i].imageType == '居住证') {
            that.verifyResult5 = STATUSMAP[res.rows[i].verifyResult] ? STATUSMAP[res.rows[i].verifyResult].verifyResult : null
          } else if (res.rows[i].imageType == '工作材料') {
            that.verifyResult6 = STATUSMAP[res.rows[i].verifyResult] ? STATUSMAP[res.rows[i].verifyResult].verifyResult : null
          }
        }

      }
    },
    async getDetail() {
      let that = this
      let { studentId } = this.$route.query;
      this.studentId = studentId
      let url = getselectAllInfo + studentId
      let res = await this.$get(url);
      console.log(res);
      if (res.isSucceed && res.rows && res.rows.length > 0) {
        this.studentType = res.rows[0].studentType
        this.residencePermitName = res.rows[0].residencePermitName
        this.publicktype = res.rows[0].schoolType
        this.workName = res.rows[0].workName
        this.busWorkType = res.rows[0].busWorkType
        if (res.rows[0].landNum) {
          this.landquery.landnum = res.rows[0].landNum
        }
        that.data0 = [{ title1: '学生姓名', title2: res.rows[0].studentName, title3: '性别', title4: res.rows[0].studentSex },
        { title1: '国家地区', title2: res.rows[0].studentArea, title3: '民族', title4: res.rows[0].nation },
        { title1: '身份证号', title2: res.rows[0].studentIdcardNum, title3: '报名年级', title4: res.rows[0].enrollmentGrade },
        { title1: '出生日期', title2: res.rows[0].studentBirthDate, title3: '手机号', title4: res.rows[0].studentPhone },
        ]
        that.data1 = [
          { title1: '户主姓名', title2: res.rows[0].householdHeadName, title3: '户号', title4: res.rows[0].householdRegistrationNum },
          { title1: '学生籍贯', title2: res.rows[0].studentHometown ? res.rows[0].studentHometown.replace('undefined', '') : '', title3: '学生与户主关系', title4: res.rows[0].registerWithStudent },
          { title1: '户籍完整地址', title2: res.rows[0].registerAddress, title3: '', title4: '' },
        ]

        if (res.rows[0].estateCertType == '不动产权证(房产证)') {
          that.data2 = [{ title1: '房产证件类型', title2: res.rows[0].estateCertType, title3: '不动产权证(房产证)编号', title4: res.rows[0].estateNumber },
          { title1: '产权人姓名', title2: res.rows[0].estateOwnerName, title3: '产权人身份证号', title4: res.rows[0].estateOwnerIdcard },
          { title1: '产权人与学生关系', title2: res.rows[0].estateWithStudent, title3: '产权比例', title4: res.rows[0].proportionOfPropertyRights },
          { title1: '第二产权人', title2: res.rows[0].estateSecondName, title3: '第二产权人身份证号', title4: res.rows[0].estateSecondIdcard },
          { title1: '第二产权比例', title2: res.rows[0].estateSecondProportionOfPropertyRights, title3: '房屋完整地址', title4: res.rows[0].houseAddress },
          { title1: '现地丘号', title2: res.rows[0].landNum, title3: '原地丘号', title4: res.rows[0].beforeLandNum },
          { title1: '小区名称', title2: res.rows[0].residentialName, title3: '', title4: "" },
          ]
        } else if (res.rows[0].estateCertType == '购房合同(预告登记)') {
          that.data2 = [{ title1: '房产证件类型', title2: res.rows[0].estateCertType, title3: '合同编号', title4: res.rows[0].estateNumber },
          { title1: '购置时间', title2: res.rows[0].processingTime, title3: '交房日期', title4: res.rows[0].jfrq },
          { title1: '契税号', title2: res.rows[0].taxNumber, title3: '契税时间', title4: res.rows[0].taxTime },
          { title1: '产权人姓名', title2: res.rows[0].estateOwnerName, title3: '产权人身份证号', title4: res.rows[0].estateOwnerIdcard },
          { title1: '产权人与学生关系', title2: res.rows[0].estateWithStudent, title3: '房屋完整地址', title4: res.rows[0].houseAddress },
          { title1: '现地丘号', title2: res.rows[0].landNum, title3: '原地丘号', title4: res.rows[0].beforeLandNum },
          { title1: '小区名称', title2: res.rows[0].residentialName, title3: '', title4: "" },
          ]
        } else if (res.rows[0].estateCertType == '房屋租赁备案证明') {
          that.data2 = [{ title1: '房产证件类型', title2: res.rows[0].estateCertType, title3: '备案证明编号', title4: res.rows[0].estateNumber },
          { title1: '产权人姓名', title2: res.rows[0].estateOwnerName, title3: '产权人身份证号', title4: res.rows[0].estateOwnerIdcard },
          { title1: '租赁备案日期', title2: res.rows[0].processingTime, title3: '承租人姓名', title4: res.rows[0].leasee },
          { title1: '承租人身份证号', title2: res.rows[0].leaseeCode, title3: '租赁年限', title4: res.rows[0].leaseYears > 0 ? ('满' + res.rows[0].leaseYears + '年') : '不满一年' },
          { title1: '租赁开始时间', title2: res.rows[0].leaseBeginDate, title3: '租赁结束时间', title4: res.rows[0].leaseEndDate },
          { title1: '承租人与学生关系', title2: res.rows[0].estateWithStudent, title3: '房屋完整地址', title4: res.rows[0].houseAddress },
          { title1: '现地丘号', title2: res.rows[0].landNum, title3: '原地丘号', title4: res.rows[0].beforeLandNum },
          { title1: '小区名称', title2: res.rows[0].residentialName, title3: '', title4: "" },
          ]
          if (res.rows[0].otherCompactCode2) {
            that.data2 = that.data2.concat([{ title1: '房屋租赁备案号2', title2: res.rows[0].otherCompactCode2, title3: '租赁备案日期2', title4: res.rows[0].otherCompactDate2 },
            { title1: '租赁开始时间2', title2: res.rows[0].leaseBeginDate2, title3: '租赁结束时间2', title4: res.rows[0].leaseEndDate2 },
            { title1: '房屋完整地址2', title2: res.rows[0].otherHouseAddress2, title3: '', title4: '' }])
          }
          if (res.rows[0].otherCompactCode3) {
            that.data2 = that.data2.concat([{ title1: '房屋租赁备案号3', title2: res.rows[0].otherCompactCode3, title3: '租赁备案日期3', title4: res.rows[0].otherCompactDate3 },
            { title1: '租赁开始时间3', title2: res.rows[0].leaseBeginDate3, title3: '租赁结束时间3', title4: res.rows[0].leaseEndDate3 },
            { title1: '房屋完整地址3', title2: res.rows[0].otherHouseAddress3, title3: '', title4: '' }])
          }
          if (res.rows[0].otherCompactCode4) {
            that.data2 = that.data2.concat([{ title1: '房屋租赁备案号4', title2: res.rows[0].otherCompactCode4, title3: '租赁备案日期4', title4: res.rows[0].otherCompactDate4 },
            { title1: '租赁开始时间4', title2: res.rows[0].leaseBeginDate4, title3: '租赁结束时间4', title4: res.rows[0].leaseEndDate4 },
            { title1: '房屋完整地址4', title2: res.rows[0].otherHouseAddress4, title3: '', title4: '' }])
          }
          if (res.rows[0].otherCompactCode5) {
            that.data2 = that.data2.concat([{ title1: '房屋租赁备案号5', title2: res.rows[0].otherCompactCode5, title3: '租赁备案日期5', title4: res.rows[0].otherCompactDate5 },
            { title1: '租赁开始时间5', title2: res.rows[0].leaseBeginDate5, title3: '租赁结束时间5', title4: res.rows[0].leaseEndDate5 },
            { title1: '房屋完整地址5', title2: res.rows[0].otherHouseAddress5, title3: '', title4: '' }])

          }
        } else if (res.rows[0].estateCertType == '自建房') {
          that.data2 = [{ title1: '房产证件类型', title2: res.rows[0].estateCertType, title3: '证件编号', title4: res.rows[0].estateNumber },
          { title1: '使用人姓名', title2: res.rows[0].estateOwnerName, title3: '使用人身份证号', title4: res.rows[0].estateOwnerIdcard },
          { title1: '现地丘号', title2: res.rows[0].landNum, title3: '原地丘号', title4: res.rows[0].beforeLandNum },
          { title1: '使用人与学生关系', title2: res.rows[0].estateWithStudent, title3: '房屋完整地址', title4: res.rows[0].houseAddress }]
        }
        that.data3 = [
          { title1: '与学生关系', title2: res.rows[0].relationshipWithStudent, title3: '姓名', title4: res.rows[0].guardianName },
          { title1: '性别', title2: res.rows[0].guardianSex, title3: '国家地区', title4: res.rows[0].guardianArea },
          { title1: '证件类型', title2: res.rows[0].guardianCertType, title3: '证件号', title4: res.rows[0].guardianIdCardNum },
          { title1: '手机号码', title2: res.rows[0].phone, title3: '工作单位', title4: res.rows[0].employer },
          { title1: '户籍地址', title2: res.rows[0].residenceAddress, title3: '', title4: '' },
        ]
        that.data4 = [
          { title1: '与学生关系', title2: res.rows[0].relationshipWithStudent2, title3: '姓名', title4: res.rows[0].guardianName2 },
          { title1: '性别', title2: res.rows[0].guardianSex2, title3: '国家地区', title4: res.rows[0].guardianArea2 },
          { title1: '证件类型', title2: res.rows[0].guardianCertType2, title3: '证件号', title4: res.rows[0].guardianIdCardNum2 },
          { title1: '手机号码', title2: res.rows[0].phone2, title3: '工作单位', title4: res.rows[0].employer2 },
          { title1: '户籍地址', title2: res.rows[0].residenceAddress2, title3: '', title4: '' },
        ]
        that.data5 = [
          { title1: '居住证姓名', title2: res.rows[0].residencePermitName, title3: '签发派出所', title4: res.rows[0].issuingPoliceStation },
          { title1: '居住证办理日期', title2: res.rows[0].earliestProcessingTime ? that.$util.FormatDate(Number(res.rows[0].earliestProcessingTime), "yyyy-MM-dd") : '', title3: '居住证开始有效期', title4: res.rows[0].validityPeriodBeginDate ? that.$util.FormatDate(Number(res.rows[0].validityPeriodBeginDate), "yyyy-MM-dd") : '' },
          { title1: '居住证结束有效期', title2: res.rows[0].validityPeriodEndDate ? that.$util.FormatDate(Number(res.rows[0].validityPeriodEndDate), "yyyy-MM-dd") : '', title3: '最近居住证登记地址', title4: res.rows[0].recentResidencePermitAddress },
          { title1: '上一张居住证开始有效期', title2: res.rows[0].lastValidityPeriodBeginDate ? that.$util.FormatDate(Number(res.rows[0].lastValidityPeriodBeginDate), "yyyy-MM-dd") : '', title3: '上一张居住证结束有效期', title4: res.rows[0].lastValidityPeriodEndDate ? that.$util.FormatDate(Number(res.rows[0].lastValidityPeriodEndDate), "yyyy-MM-dd") : '' },
          { title1: '再上一张居住证开始有效期', title2: res.rows[0].againLastValidityPeriodBeginDate ? that.$util.FormatDate(Number(res.rows[0].againLastValidityPeriodBeginDate), "yyyy-MM-dd") : '', title3: '再上一张居住证结束有效期', title4: res.rows[0].againLastValidityPeriodEndDate ? that.$util.FormatDate(Number(res.rows[0].againLastValidityPeriodEndDate), "yyyy-MM-dd") : '' },
        ]

        if (this.busWorkType == '经营') {
          that.data6 = [
            { title1: '工作人姓名', title2: res.rows[0].busWorkName, title3: '工作类型', title4: res.rows[0].busWorkType },
            { title1: '统一社会信用代码', title2: res.rows[0].creditCode, title3: '经营执照名称', title4: res.rows[0].businessLicenseName },
            { title1: '法人或经营者姓名', title2: res.rows[0].juridicalPersonName, title3: '注册日期', title4: res.rows[0].licenseRegistrationDate },
            { title1: '经营场所', title2: res.rows[0].businessPlace, title3: '缴税信息', title4: res.rows[0].paymentTax }
          ]
        } else {
          that.data6 = [
            { title1: '工作人姓名', title2: res.rows[0].workName, title3: '工作类型', title4: res.rows[0].workType },
            { title1: '劳动合同签订日期', title2: res.rows[0].laborContractDate ? that.$util.FormatDate(Number(res.rows[0].laborContractDate), "yyyy-MM-dd") : '', title3: '用人单位全称', title4: res.rows[0].workUnit },
            { title1: '用人单位地址', title2: res.rows[0].workUnitAddress, title3: '社保缴纳方式', title4: res.rows[0].socialSecurityType },
            { title1: '社保缴纳开始日期', title2: res.rows[0].socialSecurityBeginDate, title3: '社保缴纳月数', title4: res.rows[0].socialSecurityMonths },
            { title1: '参保单位名称', title2: res.rows[0].socialSecurityUnit, title3: '参保单位地址', title4: res.rows[0].socialSecurityUnitAddress },
          ]
        }

        if (that.schooltype == 3) {
          that.dataresult = [
            { title1: '初审状态', title2: resulttype[res.rows[0].firstCheckStatus != null ? res.rows[0].firstCheckStatus : null], title3: '复审状态', title4: resulttype[res.rows[0].secondCheckStatus != null ? res.rows[0].secondCheckStatus : null], title5: '交叉复审状态', title6: resulttype[res.rows[0].thirdCheckStatus != null ? res.rows[0].thirdCheckStatus : null] },
            { title1: '初审备注', title2: res.rows[0].firstCheckRemark, title3: '复审备注', title4: res.rows[0].secondCheckRemark, title5: '交叉复审备注', title6: res.rows[0].thirdCheckRemark },
            { title1: '初审用户', title2: res.rows[0].firstCheckUser, title3: '复审用户', title4: res.rows[0].secondCheckUser, title5: '交叉复审用户', title6: res.rows[0].thirdCheckUser },
            { title1: '初审时间', title2: res.rows[0].firstCheckTime ? this.$util.FormatDate(Number(res.rows[0].firstCheckTime), "yyyy-MM-dd") : '', title3: '复审时间', title4: res.rows[0].secondCheckTime ? this.$util.FormatDate(Number(res.rows[0].secondCheckTime), "yyyy-MM-dd") : '', title5: '交叉复审时间', title6: res.rows[0].thirdCheckTime ? this.$util.FormatDate(Number(res.rows[0].thirdCheckTime), "yyyy-MM-dd") : '' },
            { title1: '初审人部门', title2: res.rows[0].firstCheckSchool, title3: '复审人部门', title4: res.rows[0].secondCheckSchool, title5: '交叉复审人部门', title6: res.rows[0].thirdCheckSchool }
          ]
        } else {
          that.dataresult = [
            { title1: '审核状态', title2: resulttype1[res.rows[0].firstCheckStatus != null ? res.rows[0].firstCheckStatus : null], title3: '审核备注', title4: res.rows[0].firstCheckRemark },
            { title1: '审核用户', title2: res.rows[0].firstCheckUser, title3: '审核时间', title4: res.rows[0].firstCheckTime ? this.$util.FormatDate(Number(res.rows[0].firstCheckTime), "yyyy-MM-dd") : '' },
            { title1: '审核人部门', title2: res.rows[0].firstCheckSchool, title3: '', title4: '' }
          ]
        }

      }
    },
    async handleBtn(type) {
      let that = this
      if (type == "checkPass") {
        let checkbox0result = this.formItem.checkbox0
        let checkbox1result = this.formItem.checkbox1
        let checkbox2result = this.formItem.checkbox2
        let checkbox3result = this.formItem.checkbox3
        let checkbox4result = this.formItem.checkbox4
        let checkbox5result = this.formItem.checkbox5
        let checkbox6result = this.formItem.checkbox6
        console.log(checkbox0result, checkbox1result, checkbox2result, checkbox3result)
        if (this.verifyResult != '大数据校验成功') {
          if (!checkbox0result) {
            this.$Message.success("基本信息未审核");
            return;
          }
        }
        if (this.verifyResult1 != '大数据校验成功') {
          if (!checkbox1result) {
            this.$Message.success("户籍信息未审核");
            return;
          }
        }
        if (this.verifyResult3 != '大数据校验成功') {
          if (!checkbox3result) {
            this.$Message.success("监护人一信息未审核");
            return;
          }
        }
        if (this.verifyResult4 != '大数据校验成功') {
          if (!checkbox4result) {
            this.$Message.success("监护人二信息未审核");
            return;
          }
        }
        if (this.publicktype != 3) {
          if (this.verifyResult2 != '大数据校验成功') {
            if (this.studentType != 3) {
              if (!checkbox2result) {
                this.$Message.success("居住信息未审核");
                return;
              }
            }
          }

          if (this.verifyResult5 != '大数据校验成功') {
            if (this.schooltype != 3 && this.residencePermitName) {
              if (!checkbox5result) {
                this.$Message.success("居住证信息未审核");
                return;
              }
            }
          }
          if (this.verifyResult6 != '大数据校验成功') {
            if (this.schooltype != 3 && this.workName) {
              if (!checkbox6result) {
                this.$Message.success("工作信息未审核");
                return;
              }
            }
          }
        }

        console.log(this.formItems)
        if (!this.formItems.selects) {
          this.$Message.success("请选择审核结果");
          return;
        }
        if (!this.formItems.tips) {
          this.$Message.success("请输入审核备注");
          return;
        }
        if (this.verifyResult == '大数据校验成功') {
          this.studentInfo = true
        } else {
          if (checkbox0result == '基本信息合格') {
            this.studentInfo = true
          } else {
            this.studentInfo = false
          }
        }
        if (this.verifyResult1 == '大数据校验成功') {
          this.studentRegister = true
        } else {
          if (checkbox1result == '户籍信息合格') {
            this.studentRegister = true
          } else {
            this.studentRegister = false
          }
        }
        if (this.publicktype != 3) {
          if (this.verifyResult2 == '大数据校验成功') {
            this.studentEstate = true
          } else {
            if (checkbox2result == '房产信息合格') {
              this.studentEstate = true
            } else {
              this.studentEstate = false
            }
          }
        }

        if (this.verifyResult3 == '大数据校验成功') {
          this.studentGuardianOne = true
        } else {
          if (checkbox3result == '身份证件1合格') {
            this.studentGuardianOne = true
          } else {
            this.studentGuardianOne = false
          }
        }
        if (this.verifyResult4 == '大数据校验成功') {
          this.studentGuardianTwo = true
        } else {
          if (checkbox4result == '身份证件2合格') {
            this.studentGuardianTwo = true
          } else {
            this.studentGuardianTwo = false
          }
        }
        if (this.publicktype != 3) {
          if (this.schooltype != 3 && this.residencePermitName) {
            if (this.verifyResult5 == '大数据校验成功') {
              this.studentPermit = true
            } else {
              if (checkbox5result == '居住证合格') {
                this.studentPermit = true
              } else {
                this.studentPermit = false
              }
            }
          }
        }
        if (this.publicktype != 3) {
          if (this.schooltype != 3 && this.workName) {
            if (this.verifyResult6 == '大数据校验成功') {
              this.studentWork = true
            } else {
              if (checkbox6result == '工作信息合格') {
                this.studentWork = true
              } else {
                this.studentWork = false
              }
            }
          }
        }

        let checkStatus = 0

        if (this.auditPermissions == 1) {
          if (this.formItems.selects == "通过") {
            checkStatus = 1
          } else {
            checkStatus = 2
          }
        } else if (this.auditPermissions == 2) {
          if (this.formItems.selects == "通过") {
            checkStatus = 3
          } else {
            checkStatus = 4
          }
        }
        let data = {
          "checkUid": localStorage["uid"],
          "checkStatus": checkStatus,
          "newStudentId": this.studentId,
          "checkRemark": this.formItems.tips,
          "studentInfo": this.studentInfo,
          "studentRegister": this.studentRegister,
          "studentGuardianOne": this.studentGuardianOne,
          "studentGuardianTwo": this.studentGuardianTwo,
          "studentEstate": this.studentEstate,
          "studentPermit": this.studentPermit,
          "studentWork": this.studentWork,
        }
        console.log(data)
        let url = getadminVerify + this.auditPermissions
        let res = await that.$post(url, {
          ...data,
        });
        console.log(res);
        if (res.isSucceed) {
          that.$Message.success("审核完成");
          that.$router.back(-1)
        } else {
          that.$Message.success("审核失败");
        }

      }
    },
    isInArray(arr, value) {
      for (var i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
          return true;
        }
      }
      return false;
    },
    async showLiveInfo (data){
      let res = await this.$get(getJudicialDetail, {
        estateProveNO: data[0].title4,
        orderType: 10
      });

      if(res.isSucceed){
        if(res.rows.length > 0){
          // let estateOwner = data[1].title2
          // let estateOwnerId = data[1].title4
          let resData = res.rows[0].list[0]

          // resData.estateOwner = estateOwner
          // resData.estateOwnerId = estateOwnerId

          this.liveInfoDate = resData
          this.liveModalVisible = true
        }else{
          this.$Message.warning('没有查询到记录');
        }
      }
    },
    async showEstateInfo(userName, idCardNO){
      let res = await this.$get(getEstateList, {
        userName,
        idCardNO
      });
      
      if(res.isSucceed){
        if(res.rows.length > 0){
          this.estateInfoDate = res.rows
          this.estateInfoVisible = true
        } else {
          this.$Message.warning('没有查询到房产记录');
        }
      }
    },
    async showSelectGuardianEstateByCardno(userName, idCardNO){
      let res = await this.$get(getselectGuardianEstateByCardno, {
        userName,
        idCardNO
      });
     
      
      if(res.isSucceed){
        if(res.rows.length > 0){
          res.rows.forEach(item => {
            if (item.estateStatus == 1) {
              item.estateStatus = "正常可用";
            }
          })

          this.estateInfoDate1 = res.rows
          this.estateInfoVisible1 = true
        } else {
          this.$Message.warning('没有查询到购房合同(预告登记)记录');
        }
      }
    }
  },
  created() {
    this.getDetail();
    this.selectVerifyImage()
    this.getselectVerifyInfo()
    this.getselectVerifyRemark()
    this.getsetLandNumAuth()
    let { schooltype, iseducation, auditPermissions, page, publictype } = this.$route.query;
    if (page) {
      this.page = page
    }
    if (schooltype) {
      this.schooltype = schooltype
    }
    this.publictype = publictype
    console.log(iseducation)
    this.iseducation = iseducation
    this.auditPermissions = auditPermissions
  }
};
</script>

<style  scoped lang="less">
.content {
  margin: 0 20px 20px 20px;
}

.detailbox {
  width: 100%;
  background: #FFFFFF;
  margin-top: 30px;
  position: relative;
}
.modifylandnumbox{
  position: absolute;
  display: flex;
  align-items: center;
  right: 30px;
  top: 14px;
  height: 35px;
  width: 245px;
  justify-content: space-between;
}
.modifylandnum1{
  // position: absolute;
  // right: 90px;
  // top: 14px;
  width: 150px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #FFFFFF;
  background: #FF7943;
  border-radius: 6px;
}
.modifylandnum {
  // position: absolute;
  // right: 30px;
  // top: 14px;
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #FFFFFF;
  background: #FF7943;
  border-radius: 6px;
}

.boxtop {
  width: 100%;
  height: 58px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  border-bottom: solid 1px #DDDDDD;
}

.boxtop span:nth-child(1) {
  font-size: 18px;
  color: #4B4B4B;
  margin-left: 20px;
}

.boxtop span:nth-child(2) {
  font-size: 14px;
  color: #1AB133;
  margin-left: 8px;
}

.boxtop span:nth-child(3) {
  font-size: 14px;
  color: #1AB133;
  margin-left: 10px;
}

.infobox {
  padding: 20px;
  width: 100%;
  display: flex;
  display: -webkit-flex;
}

.infoboxleft {
  width: 67%;
}

.infoboxright {
  margin-left: 3.8%;
}

.infoboxright .ivu-checkbox-group {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
}

.infoboxright .ivu-radio-group {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
}

.resultbox {
  width: 100%;
  padding: 20px 0;
}

.boxtop1 {
  width: 100%;
  height: 58px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  border-bottom: solid 1px #DDDDDD;
  justify-content: space-between;
}

.boxtop1 div:nth-child(1) {
  font-size: 18px;
  color: #4B4B4B;
  margin-left: 20px;
}

.boxtop1 div:nth-child(2) {
  height: 28px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.boxtop1 div:nth-child(2) span {
  padding: 0px 8px;
  background: #FF7943;
  border-radius: 4px;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 28px;
  text-align: center;
  margin-right: 14px;
}

.imgbox {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  padding-bottom: 20px;
}

.imgbox img {
  width: 200px;
  height: 200px;
  margin-top: 20px;
  margin-left: 20px;
}
</style>
